import ActionButton from 'components/ActionButton';
import SearchBar from 'components/Autosuggest/Autosuggest';
import React, { useEffect, useState } from 'react';
import { searchUserByName } from 'services/api/common';
import styles from './index.module.scss';
import qs from 'query-string';
import AccountsDropdown from 'components/AccountsDropdown';
import SupplierDropdown from 'components/SupplierDropdown';

const Filter = props => {
  const [user, setUser] = useState<Record<string, any>>({});
  const [userId, setUserId] = useState<string>('');  
  const [userPhone, setUserPhone] = useState<string>('');
  const [userEmail, setUserEmail] = useState<string>('');
  const [accountId, setAccountId] = useState<string>('');
  const [supplierId, setSupplierId] = useState<string>('');

  useEffect(() => {
    const {
      userId,
      userEmail,
      accountId,
      supplierId,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    setUserId(userId?.toString() || '');
    setUserEmail(userEmail?.toString() || '');
    setUserPhone(userPhone?.toString() || '');
    setAccountId(accountId?.toString() || '');
    setSupplierId(supplierId?.toString() || '');
  }, []);


  const resetFilter = () => {
    setUser({});
    setUserId('');
    setUserEmail('');
    setUserPhone('');
    setAccountId('');
    setSupplierId('');
    const filterData = {
      userId: '',
      userEmail: '',
      accountId: '',
      supplierId: '',
    };
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    const filterData: Record<string, any> = {
      userId,
      userEmail,
      userPhone,
      accountId,
      supplierId,
    };
    props.onSubmit(filterData);
  };

  const handleUserSelect = (suggestion: Record<string,any>) => {
    const user: Record<string, any> = {};
    user.id = suggestion.objectId;
    user.name = suggestion.full_name;
    setUser(user);
    setUserId(user.id);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>User</div>
        <div className={styles['autosuggest-input']}>
          <SearchBar
            isUser={true}
            value={user.name || ''}
            setValue={value => setUser({ ...user, name: value })}
            searchAPI={searchUserByName}
            searchAPIParamKey={'searchTerm'}
            onSuggestionClicked={handleUserSelect}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User ID</div>
        <input
          className={'form-control'}
          value={userId}
          onChange={e => setUserId(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User Phone</div>
        <input
          className={'form-control'}
          value={userPhone}
          onChange={e => setUserPhone(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User Email</div>
        <input
          className={'form-control'}
          value={userEmail}
          onChange={e => setUserEmail(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Account</div>
        <AccountsDropdown
          value={accountId}
          onChange={setAccountId}
          showUserSelect={false}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Supplier</div>
        <SupplierDropdown
          selectedSupplier={supplierId}
          setSelectedSupplier={supplier => setSupplierId(supplier)}
        />
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;